import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration
// Configuration copied from twerceapp project
export const firebaseConfig = {
  apiKey: "AIzaSyCCE3kVuhxehgLzGBIvMj7hX2baYCAvcaQ",
  authDomain: "twerceapp.firebaseapp.com",
  projectId: "twerceapp",
  storageBucket: "twerceapp.appspot.com",
  messagingSenderId: "918156256787",
  appId: "1:918156256787:web:23fd6b67c42778f6ff41e6",
  measurementId: "G-0GJPQR3NCV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Google Client IDs for reference (from mobile app):
// Web Client ID: 918156256787-gl4jipeeb84ocnd7be6ch5iic45a8v2q.apps.googleusercontent.com
// iOS Client ID: 918156256787-96q9ugq3485u3j77ugkmksp3mk4b851s.apps.googleusercontent.com
// Android Client ID: 918156256787-7u4le13o7n2vc4g26dbe1caj1hs3q00c.apps.googleusercontent.com

// Instructions for setup:
// 1. Go to https://console.firebase.google.com/
// 2. Select your project (twerceapp)
// 3. Go to Project Settings > General
// 4. Scroll down to "Your apps" section
// 5. Click "Add app" and select Web
// 6. Copy the configuration object
// 7. Replace the values above with your actual config
// 8. Enable Authentication in Firebase Console
// 9. Enable Google Sign-In in Authentication > Sign-in method
// 10. Use the correct web client ID: 918156256787-gl4jipeeb84ocnd7be6ch5iic45a8v2q.apps.googleusercontent.com
// 11. Enable Firestore Database in Firebase Console 
// 12. Enable Storage in Firebase Console 